import CumulDashboard from "@mapmycustomers/shared/types/cumul/CumulDashboard";

import Path from "@app/enum/Path";
import ReportsMenuOptions from "@app/enum/ReportsMenuOptions";

const UPGRADE_PROMOTION_USER_THRESHOLD = 10;

export interface ReportsDefaultPathInputs {
  isCumulEnabled?: boolean;
  isCumulPromotionalUIVisited?: boolean;
  isOwnerOrManager?: boolean;
  pinnedDashboards: CumulDashboard[];
  userCount: number;
}

const resolveReportsDefaultPath = ({
  isCumulEnabled,
  isCumulPromotionalUIVisited,
  isOwnerOrManager,
  pinnedDashboards,
  userCount,
}: ReportsDefaultPathInputs): string => {
  if (isCumulEnabled) {
    const [firstPinnedDashboard] = pinnedDashboards;
    return firstPinnedDashboard
      ? `${Path.REPORTS}/dashboard/${firstPinnedDashboard.id}`
      : `${Path.REPORTS}/${ReportsMenuOptions.ALL_DASHBOARDS}`;
  }

  const showsUpgradePromotion =
    !isCumulPromotionalUIVisited &&
    !!isOwnerOrManager &&
    userCount > UPGRADE_PROMOTION_USER_THRESHOLD;

  return `${Path.REPORTS}/${
    showsUpgradePromotion ? ReportsMenuOptions.UPGRADE_YOUR_REPORTS : ReportsMenuOptions.OVERVIEW
  }`;
};

export default resolveReportsDefaultPath;
